import { thunk } from 'redux-thunk';

import { syncLocalStorageUser } from './syncLocalStorageUser';

function removeEmpty(array) {
  return array.filter(Boolean);
}

const middlewares = [...removeEmpty([thunk, syncLocalStorageUser])];

export default middlewares;
